import React from "react";
import { useAuth } from "../../contexts/authContext";
import { useNavigate, Link } from 'react-router'

import { app } from '../../firebase/firebase';
import { getPremiumStatus } from "../stripe/subscriptionStatus.ts";
import { useEffect, useState } from "react";
import { auth } from "../../firebase/firebase";
import { setAuthState, Events } from "../../firebase/telemetry";
import { logError } from "../../firebase/errorReporting";

export const SubscriptionGaurd = ({ component: C }) => {
  const { userLoggedIn } = useAuth();

  const navigate = useNavigate()
  const [page, setPage] = useState(<div className="page-layout"></div>);

  useEffect(() => {
    getPremiumStatus(app).then(e => {
      // The one place entitlement is known. Setting it here is what makes every
      // other event in GA4 splittable by paying vs non-paying.
      setAuthState(e ? 'premium' : 'signed_in');
      if (e) {
        setPage(<C />);
        Events.appOpenMap();
      } else {
        Events.paywallShown('no_subscription');
        navigate('/subscribe')
      }
    }).catch(err => {
      // A Firestore read failure here used to leave the user on a blank page
      // with nothing logged anywhere.
      logError(err, { component: 'SubscriptionGaurd' });
      navigate('/subscribe')
    });

  }, [app, auth.currentUser?.uid]);
  return (
    <>
      {page}
    </>
  )
};